import type { TaskDefinition } from '../../../config/types';
import { onboardingTasks, reviewTeams } from '../../../config/constants';

export const completeInventory: TaskDefinition = {
  taskName: onboardingTasks.CompleteInventory,
  config: {
    staffDisplayName: 'Self-guided inspection',
    appcuesModalId: '473c8d96-e71d-4ea5-83a6-ccf5078c96ea',
    reviewTeam: reviewTeams.uwOps,
    daysAllowed: 15,
    enabled: true,
    eventName: 'Completed self-guided inspection',
    account: {
      content: ({ affectedPolicies, daysAllowed, brandName }) => ({
        title: 'Complete self-guided inspection',
        incompleteSubtitle: 'Secure your home discount by submitting photos of your home and any other covered items.',
        completedSubtitle: `You have successfully submitted for review the self-guided inspection photos for policy ${affectedPolicies}.`,
        actionLabel: 'Complete now',
        contentSections: [
          {
            title: 'How does this work?',
            body: `The photos you upload will be submitted for review by a ${brandName} representative.`
          },
          {
            title: 'When do I need to submit these documents?',
            body: `You have ${daysAllowed} days from your policy effective date to turn in verification listed above before the discount is removed.`
          }
        ]
      })
    }
  }
};
